import { Block, Flex, Input, InputType, SizeProperty, Typography } from '@aloft/toolkit-sui';

import { Controller } from 'react-hook-form';

export const OrderDetailsInput = ({
  control,
  placeholderText,
  type = 'text',
  isRequired = false,
  width = '250px',
  name,
  label,
  errorMessage,
}: {
  control: any;
  placeholderText?: string;
  type?: InputType;
  isRequired?: boolean;
  width?: SizeProperty;
  name: string;
  label: string;
  errorMessage?: string;
}) => (
  <Flex>
    <Block width="250px">
      <div style={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
        <Typography variant="h4" color="textSecondary">
          {label}
        </Typography>
        {isRequired && <span style={{ color: 'red' }}> *</span>}
      </div>
    </Block>
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired,
      }}
      render={({ field, fieldState }) => {
        // Use form validation error if available, otherwise use custom validation error
        const formError = fieldState.error?.message;
        const customError = errorMessage;
        const hasError = formError || customError;

        return (
          <Block width={width}>
            <Input
              size="sm"
              type={type as any}
              placeholderText={placeholderText}
              isInvalid={!!hasError}
              {...field}
              onClear={() => {
                field.onChange('');
              }}
              isRequired={isRequired}
            />
            {!!hasError && (
              <Typography variant="body2" color="error">
                {formError || customError}
              </Typography>
            )}
          </Block>
        );
      }}
    />
  </Flex>
);
